import { render, staticRenderFns } from "./AppNavigationImportBoard.vue?vue&type=template&id=5a039f34"
import script from "./AppNavigationImportBoard.vue?vue&type=script&lang=js"
export * from "./AppNavigationImportBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports